import { Flex, Input } from "antd";

const { TextArea } = Input;

const CustomTextarea = ({
  title,
  placeholder = "-",
  value,
  onChange,
  style,
  onKeyDown,
  autoFocus = false,
  prefix,
  required,
  showCount,
  maxLength = 400,
  readOnly = false,
}) => {
  return (
    <Flex vertical gap={"2px"} style={{ width: "100%" }}>
      {title && (
        <p style={{ fontSize: "13px" }}>
          {required && <span style={{ color: "#f00" }}>*</span>}
          {title}:
        </p>
      )}
      <TextArea
        readOnly={readOnly}
        autoFocus={autoFocus}
        showCount={showCount}
        maxLength={maxLength}
        value={value}
        onChange={onChange}
        prefix={prefix}
        placeholder={placeholder}
        style={{ ...style, minHeight: "100px" }}
        onKeyDown={onKeyDown}
        // disabled={readOnly}
      />
    </Flex>
  );
};

export default CustomTextarea;
